<template>



  <div class="news-detail">
    <app-header></app-header>
    <main >
        <div class="container-fluid">
          <h1 class="title">{{ news.title }}</h1>
        </div>

        <div
          class="news-image">
          <agile v-if="images.length > 0" :navButtons="false" :dots="false" :infinite="false" :autoplay-speed="5000">
            <div style="background-color: white" class="slide" v-for="image in images" >
              <img :src="image"  v-on:click="openImage(image)">
            </div>
          </agile>
          <div v-if="images.length == 0" class="content-center">
            <div class="center_load">
              <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div>
          </div>
        </div>
      <div  v-if="selected_image.length == 0">
        <div class="container-fluid">
          <div class="organization-name-wrapper" @click="$router.push(`/news/organization/${news.organize_id}`)">
            <div class="organization-icon">
              <fa-icon icon="tag"></fa-icon>
            </div>
            <div class="organization-name">{{ news.organize.name }}</div>
          </div>

          <div class="row no-gutters">
            <div class="col">
              <div class="address">{{ news.organize.address }}</div>
              <div class="category">ประเภท {{ news.news_type.type }}</div>
            </div>
            <div class="col text-right">
              <button
                :class="{ 'btn-border-dark': news.organize.follow, 'btn-news': !news.organize.follow }"
                class="btn btn-round"
                @click="toggleFollow(news.organize.id)">
                <fa-icon icon="heart"></fa-icon>

                <template v-if="!news.organize.follow">
                  <span>ติดตาม</span>
                </template>
                <template v-if="news.organize.follow">
                  <span>ติดตามแล้ว</span>
                </template>
              </button>
            </div>
          </div>

          <div class="timestamp">
            <fa-icon icon="clock"></fa-icon>
            <span>{{ news.published_at }}</span>
          </div>

          <div class="view-count">
            <fa-icon icon="eye"></fa-icon>
            <span>{{ news.view_count }}</span>
          </div>
        </div>

        <hr>

        <div class="container-fluid">
          <h2 class="full-title">{{ news.title }}</h2>

          <article style="word-break: break-word;" v-html="news.content"></article>
        </div>
      </div>

      <div v-on:click="closeImage(image)" v-if="selected_image.length > 0" class="wrapper-preview-image" >
        <img  :src="selected_image" class="view-image">
      </div>

    </main>
    <app-footer></app-footer>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  import AppHeader from '../components/Header.component'
  import AppFooter from '../components/Footer.component'

  export default {
    name: 'news-detail',
    components: {
      AppHeader,
      AppFooter
    },

    props: {
      newsId: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        images: [],
        selected_image: ''
      }
    },
    computed: {
      // Map Vuex state.
      ...mapState({
        news: state => {
          return {
            ...state.News.newsDetail,
            images: state.News.newsDetail.images
              ? JSON.parse(state.News.newsDetail.images).map(image => encodeURI(image))
              : [],
            updated_at: moment(state.News.newsDetail.updated_at).locale('th').fromNow()
          }
        }
      })
    },

    created () {
      this.images = []
      return this.$store.dispatch('News/getNewsDetail', this.newsId)
    },
    mounted () {
      this.images = []
      setTimeout(this.loadImage, 1000)
    },
    methods: {
      toggleFollow (organizeId) {
        return this.$store.dispatch(`Organize/followOrganization`, organizeId)
          .then(() => this.$store.dispatch('News/getNewsDetail', this.newsId))
      },
      loadImage () {
        this.images = this.news.images
      },
      openImage (image) {
        this.selected_image = image
      },
      closeImage () {
        this.selected_image = ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  .content-center{
    height: 50vw;
    width: 100vw;
    display: table;
  }

  .center_load{
    display: table-cell;
    text-align: center;
    vertical-align: middle
  }

  .wrapper-preview-image{
    height: 100vh;
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0px;
    background: black;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .view-image{
    display:block;
    marign-top: auto;
    marign-bottom: auto;
    margin-left: auto;
    margin-right: auto;
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
  }



  main {
    margin-top: calc(#{$header-height} + 15px);
    .title {
      font-size: 20px;
      margin: 10px 0;
    }
    .news-image {
      @extend .bg-cover;
      height: 50vw;
      img {
        max-height: 50vw;
        display:block;
        margin-left: auto;
        margin-right: auto;
        object-fit: contain;
        width: 100%;
      }
    }
    .organization-name-wrapper {
      @extend .d-flex;
      @extend .cursor-pointer;
      color: $news-color;
      margin: 10px 0;
      .organization-icon {
        padding-right: 5px;
      }
      .organization-name {
        @extend .flex-grow-1;
        line-height: 1;
        font-size: 16px;
      }
    }
    .address, .category, .timestamp, .view-count {
      font-size: 12px;
    }
    .timestamp {
      margin: 10px 0;
    }
    .view-count {
      margin: 10px 0;
    }

    .full-title {
      font-size: 14px;
      margin-bottom: 30px;
    }
    article {
      font-size: 12px;
    }

    .back-to-top {
      @extend .position-fixed;
      @extend .cursor-pointer;
      right: 20px;
      bottom: 40px;
      img {
        width: 34px;
        height: 34px;
      }
    }

    .lds-ellipsis {
      display: inline-block;
      position: relative;
      width: 64px;
      height: 64px;
    }
    .lds-ellipsis div {
      position: absolute;
      top: 27px;
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background: #fcf;
      animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
      left: 6px;
      animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
      left: 6px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
      left: 26px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
      left: 45px;
      animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
      0% {
        transform: scale(0);
      }
      100% {
        transform: scale(1);
      }
    }
    @keyframes lds-ellipsis3 {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(0);
      }
    }
    @keyframes lds-ellipsis2 {
      0% {
        transform: translate(0, 0);
      }
      100% {
        transform: translate(19px, 0);
      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/pages/NewsDetail.page.vue